module.exports = __webpack_public_path__ + "img/lessonattend-finger-lightgreen.f081583e.svg";